import useCommunication from "hooks/context-hooks/useCommunication";
import { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { LoaderNiMichaelGwapo } from "components/DFCustoms";
import useLogHistory from "hooks/useLogHistory";
import CommunicationCard from "./CommunicationCard";
import useMediaQuery from "hooks/useMediaQuery";

export default function Communications({ filterPosition, ...props }) {
  const { ref, inView } = useInView();
  const {
    displayFilter,
    filtersPresent,
    communications,
    fetchNextPage,
    isFetchingNextPage,
    isFetching,
    isLoading,
  } = useCommunication();

  const [renderLogHistory, { openLogHistory, patient, isOpen }] = useLogHistory(
    props.user,
    true
  );
  const isDialogMode = useMediaQuery("(max-width: 1200px)");
  useEffect(() => {
    if (inView) {
      fetchNextPage();
    }
  }, [inView]);

  const showConvo = (e) => {
    const firstName = e.first_name ? e.first_name : "";
    const lastName = e.last_name ? e.last_name : "";
    const patientData = {
      patientID: e._id,
      officeID: e.office_id,
      patientName: `${firstName} ${lastName}`,
      patientStatus: e.patient_status,
      phone1: e.phone1,
    };
    openLogHistory(patientData, e.log_id);
  };
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          height: "90vh",
          overflow: "auto",
        }}
      >
        <div
          style={{
            width: isDialogMode ? "100%" : "600px",
            // minWidth: 600,
            // width: "600px",
            overflow: "auto",
            height: "100%",
            // ...(!filterPosition && { paddingTop: filtersPresent ? 80 : 56 }),
          }}
        >
          {displayFilter(filterPosition)}
          <LoaderNiMichaelGwapo
            number_of_items={10}
            type="communication"
            isLoading={isLoading}
            isFetchingNextPage={isFetchingNextPage}
            showEmptyMessage={
              !isFetching &&
              (communications === undefined ||
                communications[0].data.length === 0)
            }
          >
            {communications?.map((page) =>
              page?.data?.map((val, idx) => (
                <CommunicationCard
                  key={val._id}
                  ref={page?.data?.length === idx + 1 ? ref : null}
                  params={val}
                  history={props.history}
                  token={props.user.token}
                  isLoading={isLoading}
                  showConvo={showConvo}
                  isOpen={patient.patientID === val._id && isOpen}
                />
              ))
            )}
          </LoaderNiMichaelGwapo>
        </div>
        <div
          style={{
            position: "relative",
            width: isDialogMode ? 0 : "calc(100% - 600px)",
            overflow: "auto",
            // height: "90vh",
            // ...(!filterPosition && { paddingTop: filtersPresent ? 80 : 56 }),
            // paddingTop: 60,
          }}
        >
          {renderLogHistory()}
        </div>
      </div>
    </div>
  );
}
